import {
  GenerateDynamicQRPayload,
  GenerateDynamicQRResponse,
  GetPaymentStatusResponse,
  RequestUPICollectionPayload,
  RequestUPICollectionResponse,
  TrackStatusPayload,
  TrackStatusResponse,
  ValidateVPAPayload,
  ValidateVPAResponse,
} from "@/utils/types/NPS/Stepper/PaymentSerice";
import { get, post } from "@/services/axiosUitils";

const validateVPAUrl = "/nps/payment/validate-vpa/";
const requestUPICollectionUrl = "/nps/payment/request-upi-collect/";
const generateDynamicQRUrl = "/nps/payment/generate-dynamic-qr/";
const getPaymentStatusUrl = "/nps/payment/payment-status/";
const trackStatusUrl = "/nps/cra/track-status/";
class PaymentService {
  validateVPA = async (
    payload: ValidateVPAPayload
  ): Promise<ValidateVPAResponse> => {
    const response = await post<ValidateVPAResponse>(
      `${validateVPAUrl}`,
      payload
    );
    return response;
  };

  requestUPICollection = async (
    payload: RequestUPICollectionPayload
  ): Promise<RequestUPICollectionResponse> => {
    const response = await post<RequestUPICollectionResponse>(
      `${requestUPICollectionUrl}`,
      payload
    );
    return response;
  };

  generateDynamicQR = async (
    payload: GenerateDynamicQRPayload
  ): Promise<GenerateDynamicQRResponse> => {
    const response = await post<GenerateDynamicQRResponse>(
      `${generateDynamicQRUrl}`,
      payload
    );
    return response;
  };

  getPaymentStatus = async (
    ackId: string
  ): Promise<GetPaymentStatusResponse> => {
    const response = await get<GetPaymentStatusResponse>(
      `${getPaymentStatusUrl}?refId=${ackId}`
    );
    return response;
  };

  trackStatus = async (
    payload: TrackStatusPayload
  ): Promise<TrackStatusResponse> => {
    const response = await post<TrackStatusResponse>(
      `${trackStatusUrl}`,
      payload
    );
    return response;
  };
}

const instance = new PaymentService();
export default instance;
